/**
 * TPL-001 — expand recurring template blocks after wizard answers.
 * Mirrors Offers::ExpandTemplateByUnits (per_unit vs once, garage option).
 */

function readCustom(row) {
  const fromFields =
    row?.custom_fields && typeof row.custom_fields === "object"
      ? row.custom_fields
      : {};
  const fromMeta =
    row?.module_graph?.meta && typeof row.module_graph.meta === "object"
      ? row.module_graph.meta
      : {};
  return { ...fromMeta, ...fromFields };
}

function globalValue(calcData, key) {
  const globals = calcData?.module_graph?.globals || [];
  const found = globals.find((g) => g?.key === key);
  return found?.value;
}

function titleFor(row, index) {
  const base = String(row?.title || row?.description || "")
    .replace(/\s*#\d+$/, "")
    .trim();
  return `${base} #${index}`;
}

function expandList(rows, unitCount) {
  const out = [];
  (rows || []).forEach((row) => {
    const scope = readCustom(row).repeat_scope || "once";
    if (scope === "per_unit") {
      for (let i = 1; i <= unitCount; i += 1) {
        out.push({
          ...row,
          title: row.title != null ? titleFor(row, i) : row.title,
          description:
            row.description != null ? titleFor(row, i) : row.description,
          custom_fields: { ...readCustom(row), unit_index: i },
        });
      }
    } else {
      out.push({ ...row, custom_fields: { ...readCustom(row) } });
    }
  });
  return out;
}

function applyGarage(rows, garageMode) {
  return (rows || []).map((row) => {
    if (readCustom(row).option_key !== "garage") return withPersistedMeta(row);
    if (garageMode === "included") {
      return withPersistedMeta({
        ...row,
        pricing_role: "included",
        visible_to_customer: true,
      });
    }
    if (garageMode === "excluded") {
      return withPersistedMeta({
        ...row,
        pricing_role: "excluded",
        visible_to_customer: false,
      });
    }
    return withPersistedMeta({ ...row, pricing_role: "optional" });
  });
}

/** Persist TPL meta on module_graph so API nested upsert can store it. */
function withPersistedMeta(row) {
  const custom = readCustom(row);
  const meta = { ...custom };
  if (row?.pricing_role) meta.pricing_role = row.pricing_role;
  if (row?.visible_to_customer != null) {
    meta.visible_to_customer = row.visible_to_customer;
  }
  return {
    ...row,
    module_graph: {
      ...(row.module_graph && typeof row.module_graph === "object"
        ? row.module_graph
        : {}),
      meta,
    },
  };
}

export function expandTemplateByUnits(calcData, overrides = {}) {
  if (!calcData) return calcData;
  const rawUnits = overrides.unitCount ?? globalValue(calcData, "unit_count") ?? 1;
  const unitCount = Math.max(1, parseInt(rawUnits, 10) || 1);
  const garage =
    overrides.garage ?? globalValue(calcData, "garage") ?? "optional";

  return {
    ...calcData,
    nested_calculations: applyGarage(
      expandList(calcData.nested_calculations, unitCount),
      garage
    ),
    items: applyGarage(expandList(calcData.items, unitCount), garage),
  };
}
